import { Label } from 'react-aria-components';
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import Select from 'react-select';

type Props<T extends FieldValues, V extends string | number> = {
  name: FieldPath<T>;
  label?: string;
  placeholder?: string;
  control: Control<T>;
  required?: boolean;
  defaultValue?: { value: V; label: string }[];
  defaultValueLabel?: string;
  disabled?: boolean;
  options: { value: V; label: string }[];
};

const MultiSelectField = <T extends FieldValues, V extends string | number>(props: Props<T, V>) => {
  return (
    <div className="relative w-full">
      <div className="flex flex-row items-center">
        <Label className="mb-2 text-lg font-bold">{props.label}</Label>
        {props.required && <span className="mb-2 ml-1 text-red-800">※必須</span>}
      </div>
      <Controller
        name={props.name}
        control={props.control}
        rules={{ required: props.required }}
        render={({ field: { onChange, value } }) => (
          <Select
            isMulti
            options={props.options}
            onChange={(selectedOptions) => {
              const values = selectedOptions.map((option) => option.value);
              onChange(values);
            }}
            defaultValue={props.defaultValue}
            value={props.options.filter(
              (option) => value && Array.isArray(value) && value.includes(option.value)
            )}
            isDisabled={props.disabled}
            placeholder={props.placeholder}
          />
        )}
      />
    </div>
  );
};

export default MultiSelectField;
